import { Select } from "antd";
import React from "react";
import Constants, { toISTDate } from '@Apis/constants';
import PRZSelect from "../../../Common/UI/PRZSelect";
const { Option } = Select;
const SelectOrdersForGRN = ({ disabled, mode, onChange, selectedPoValue, purchaseOrders, isDataMaskingPolicyEnable, isHideCostPrice, MONEY, loading, inputClassName }) => {
  return (
    <PRZSelect
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
      placeholder="Select purchase order.."
      labelInValue
      disabled={disabled}
      filterOption={false}
      showSearch
      allowClear
      value={selectedPoValue}
      maxTagCount="responsive"
      mode={mode}
      onChange={onChange}
      loading={loading}
      className={inputClassName}
    >
      {purchaseOrders?.purchase_order
        ?.filter((item) => item?.closing_status !== "CLOSED")
        ?.map((item) => (
          <Option key={item.po_id} value={item.po_id}>
            {`#${item.po_number} (${toISTDate(item.created_date || item.created_at).format(
              "DD/MM/YYYY"
            )}) - `}
            {isDataMaskingPolicyEnable && isHideCostPrice ? (
              <HideValue
                showPopOver
                popOverMessage={"You don't have access to view po amount"}
              />
            ) : (
              MONEY(
                item.po_grand_total,
                item?.org_currency_info?.currency_code
              )
            )}
          </Option>
        ))}
    </PRZSelect>
  );
};

export default SelectOrdersForGRN;
